import {Component, Input} from '@angular/core';
import {ControlContainer, FormsModule, NgForm} from '@angular/forms';
import {NgClass} from '@angular/common';
import {NlrFormFieldHasErrorPipe} from '../../pipe/nlr-form-field-has-error.pipe';
import {NlrHasPermissionsPipe} from '../../pipe/nlr-has-permissions.pipe';
import {EvidenceValidationService} from './evidence-validation.service';
import {PlanAttachment} from '../../models/plan-attachment.model';

@Component({
    selector: 'evidence-validation',
    imports: [FormsModule, NlrFormFieldHasErrorPipe, NgClass, NlrHasPermissionsPipe],
    templateUrl: './evidence-validation.component.html',
    styleUrl: './evidence-validation.component.scss',
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class EvidenceValidationComponent {
    @Input()
    attachment: PlanAttachment;

    constructor(private evidenceValidationService: EvidenceValidationService) {}

    hasValidationErrorsOrWarnings() {
        return this.evidenceValidationService.hasValidationErrorsOrWarnings(this.attachment);
    }

    hasValidationWarnings() {
        return this.evidenceValidationService.hasValidationWarnings(this.attachment);
    }

    hasValidationErrors() {
        return this.evidenceValidationService.hasValidationErrors(this.attachment);
    }

    getValidationWarnings() {
        return this.evidenceValidationService.getValidationWarnings(this.attachment);
    }

    getValidationErrors() {
        return this.evidenceValidationService.getValidationErrors(this.attachment);
    }

    getValidationWarningCount() {
        return this.evidenceValidationService.getValidationWarnings(this.attachment).length;
    }

    getValidationErrorCount() {
        return this.evidenceValidationService.getValidationErrors(this.attachment).length;
    }
}
